import { useCallback, useEffect, useRef, useState } from 'react';
import { SchoolEvent } from 'models/event';
import { getAllTournamentActiveEvents } from 'services/Tournaments/events';
import { getTournamentCompetitionRuntime, getTournamentTeams } from 'services/Tournaments/teams';

export function useTeamTournamentLiveData(schoolId: string, tournamentId: string, refreshMs = 15000) {
   const [events, setEvents] = useState<SchoolEvent[]>([]);
   const [teams, setTeams] = useState<any[]>([]);
   const [runtime, setRuntime] = useState<any>();
   const [isLoading, setIsLoading] = useState(true);
   const [error, setError] = useState('');
   const mounted = useRef(true);

   const refresh = useCallback(async (showLoader = false) => {
      if (!schoolId || !tournamentId) return;
      if (showLoader) setIsLoading(true);
      try {
         const [nextEvents, nextTeams, nextRuntime] = await Promise.all([
            getAllTournamentActiveEvents(schoolId, tournamentId, {}, true),
            getTournamentTeams(schoolId, tournamentId),
            getTournamentCompetitionRuntime(schoolId, tournamentId).catch(() => undefined)
         ]);
         if (!mounted.current) return;
         setEvents(nextEvents);
         setTeams(nextTeams);
         setRuntime(nextRuntime);
         setError('');
      } catch {
         if (mounted.current) setError('Live tournament data could not be refreshed.');
      } finally {
         if (mounted.current) setIsLoading(false);
      }
   }, [schoolId, tournamentId]);

   useEffect(() => {
      mounted.current = true;
      refresh(true);
      const timer = window.setInterval(() => refresh(false), refreshMs);
      return () => { mounted.current = false; window.clearInterval(timer); };
   }, [refresh, refreshMs]);

   return {events, teams, runtime, isLoading, error, refresh};
}
